export enum BulkUploadStepsEnum{
    UPLOAD_CSV=0,
    FIELD_MAPPING=1,
    PREVIEW=2,
    UPLOAD_PDF=3,
    MATCH_FILES = 4,
    SUMMARY=5,
    HANDLE_DUPLICATES=6
}